import { render, staticRenderFns } from "./WarnPopUp.vue?vue&type=template&id=297b1b14&scoped=true"
import script from "./WarnPopUp.vue?vue&type=script&lang=js"
export * from "./WarnPopUp.vue?vue&type=script&lang=js"
import style0 from "./WarnPopUp.vue?vue&type=style&index=0&id=297b1b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b1b14",
  null
  
)

export default component.exports